import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7j1sghpx: FaireBrandEntity = {
  token: "b_7j1sghpx",
  type: "brand",
  name: "Zippo Manufacturing Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/a33353a75ec61f16d7b0e6d619d12c0320e2886f68dd4c2ca4adb44e0edd8447.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c1799201ca8467f356938e63492f69d74b1f4648b1e9ddb58bd7c9884bca466e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a33353a75ec61f16d7b0e6d619d12c0320e2886f68dd4c2ca4adb44e0edd8447.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c1799201ca8467f356938e63492f69d74b1f4648b1e9ddb58bd7c9884bca466e.png",
  location: "Bradford, PA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 78,
  isInsider: true,
  description:
    'THE HOME OF THE ORIGINAL WINDPROOF LIGHTER. MADE IN USA SINCE 1932\n\nWelcome to the Zippo brand store on Faire, where iconic design meets unmatched durability. \n\nFor over 90 years, Zippo has been crafting lighters that aren’t just tools—they’re statements. From sleek, classic designs to bold, collectible pieces, every Zippo is built to last and backed by a lifetime guarantee.\n\n- Windproof. Refillable. Reliable.\n- Unmistakable Zippo "Click."\n- The ultimate accessory for those who live boldly\n- Proudly Made In USA\n\nShop now and bring a piece of American heritage to your store with the Zippo collection!\n\nAny questions at all - Just send us a message! ',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:50.233Z",
    importedBy: "entity-db-cli",
  },
};
